module.exports = ".error-border-password {\n  background: white;\n  border: 2px solid #e6294b;\n  border-radius: 5px;\n  padding: 15px;\n}\n"